import React from 'react';

import {
  CheckboxGroupOption,
  CheckboxGroup,
  CheckboxSubGroup,
  Section,
} from '@gogame/components';
import { withFormField } from '@gogame/form';

import { AUDIENCE_TYPES } from 'scenes/CustomAudiences/Audiences/components/AudienceForm/constants';
import { useCanEditAll } from 'scenes/CustomAudiences/EditGranularityContext';

import { NON_DEPOSITORS, REGULAR, SUBSCRIBERS, NAMES } from './constants';

const FieldSet = ({ value = [], onChange }) => {
  const canEditAll = useCanEditAll();
  //TODO: make common MUI component for typical components
  return (
    <Section required={true} title={'Purchase Data'}>
      <CheckboxGroup
        vertical={true}
        label={'Depositors'}
        value={value}
        onChange={onChange}
      >
        <CheckboxGroupOption
          value={NON_DEPOSITORS}
          label={NAMES[NON_DEPOSITORS]}
          disabled={!canEditAll}
        />
        <CheckboxSubGroup label={'Depositors'} disabled={!canEditAll}>
          <CheckboxGroupOption
            disabled={!canEditAll}
            value={SUBSCRIBERS}
            label={NAMES[SUBSCRIBERS]}
          />
          <CheckboxGroupOption
            disabled={!canEditAll}
            value={REGULAR}
            label={NAMES[REGULAR]}
          />
        </CheckboxSubGroup>
      </CheckboxGroup>
    </Section>
  );
};

export default withFormField({ name: AUDIENCE_TYPES, padding: 0 })(FieldSet);
